export const TEAMS_FILTRATION = {
    REGION: [
        { label: "Все", value: "all" },
        { label: "Москва", value: "moscow" },
        { label: "Московская область", value: "moscow_reg" },
        { label: "Санкт-Петербург", value: "spb" },
        { label: "Ленинградская область", value: "spb_reg" },
        { label: "Тульская область", value: "tula" },
        { label: "Республика Татарстан", value: "tatarstan" },
        { label: "Краснодарский край", value: "krasnodar_krai" },
        { label: "Свердловская область", value: "sverdlovsk" },
        { label: "Нижегородская область", value: "nizhny_novgorod" },
        { label: "Новосибирская область", value: "novosibirsk" },
        { label: "Приморский край", value: "primorye" },
        { label: "Калининградская область", value: "kaliningrad" },
        { label: "Чеченская Республика", value: "chechnya" },
        { label: "Республика Башкортостан", value: "bashkortostan" },
    ] as const,

    LOOKING_PROJECT: [
        { label: "Все", value: "all" },
        { label: "Идет добор в команду", value: "recruiting" },
        { label: "Команда укомплектована", value: "full" },
        { label: "Только экспертная поддержка", value: "mentoring" },
        { label: "На стадии формирования", value: "forming" },
    ] as const,

    STAGE: [
        { label: "Все", value: "all" },
        { label: "Разработка и IT", value: "tech" },
        { label: "Социальное проектирование", value: "social_design" },
        { label: "Маркетинг и коммуникации", value: "marketing" },
        { label: "Образование и методология", value: "education" },
        { label: "Экологические инициативы", value: "ecology" },
        { label: "Юридическая поддержка", value: "legal" },
    ] as const
}